(function () {
  const initProductAccordion = () => {
		document.querySelectorAll('.about__accordion-toggle').forEach((toggle) => {
			if (toggle.dataset.accordionInitialized === 'true') return;
			toggle.dataset.accordionInitialized = 'true';

			toggle.addEventListener('click', () => {
				const item = toggle.closest('.about__accordion-item');
				const description = item?.querySelector('.about__accordion-description');
				if (!description) return;

				const shouldOpen = !toggle.classList.contains('active');
				toggle.classList.toggle('active', shouldOpen);

				if (description.getAnimations) {
					description.getAnimations().forEach((animation) => animation.cancel());
				}

				if (shouldOpen) {
					description.style.display = 'block';
					description.style.overflow = 'hidden';
					const targetHeight = description.scrollHeight;
					const animation = description.animate(
						[{ height: '0px', opacity: 0 }, { height: `${targetHeight}px`, opacity: 1 }],
						{ duration: 300, easing: 'ease' }
					);
					animation.onfinish = () => {
						description.style.height = '';
						description.style.opacity = '';
						description.style.overflow = '';
					};
				} else {
					description.style.overflow = 'hidden';
					const startHeight = description.getBoundingClientRect().height;
					const animation = description.animate(
						[{ height: `${startHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
						{ duration: 300, easing: 'ease' }
					);
					animation.onfinish = () => {
						description.style.display = 'none';
						description.style.height = '';
						description.style.opacity = '';
						description.style.overflow = '';
					};
				}
			});
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;

    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const initOptionSetWidgetObserver = () => {
    const OPTION_SET_ID_PART = 'optis_product_options_option_set';
    const APP_BLOCK_SELECTOR = '.shopify-app-block.has-bss-po-widget';
    const WIDGET_SELECTOR = '.bss-po-option-set .bss-po-product-page';
    const OBSERVED_ATTR = 'data-widget-observer-init';
    const MIN_HEIGHT_VAR = '--min-height';
    
    const applyWidgetState = (appBlock) => {
      const widget = appBlock.querySelector(WIDGET_SELECTOR);
      if (!widget) return false;

      widget.classList.add('has-widget');

      const height = Math.ceil(widget.getBoundingClientRect().height || widget.scrollHeight || 0);
      if (height > 0) appBlock.style.setProperty(MIN_HEIGHT_VAR, `${height}px`);

      return true;
    };

    const observeBlock = (block) => {
      if (block.hasAttribute(OBSERVED_ATTR)) return;
      block.setAttribute(OBSERVED_ATTR, 'true');

      if (applyWidgetState(block)) return;

      const observer = new MutationObserver(() => {
        if (!document.body.contains(block)) {
          observer.disconnect();
          return;
        }

        if (applyWidgetState(block)) {
          observer.disconnect();
        }
      });

      observer.observe(block, { childList: true, subtree: true });
    };

    const appBlocks = document.querySelectorAll(APP_BLOCK_SELECTOR + '[id*="' + OPTION_SET_ID_PART + '"]');
    appBlocks.forEach(observeBlock);
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initOptionSetWidgetObserver();
  });

  initProductAccordion();
  initZoomImage();
  initOptionSetWidgetObserver();
})();
